export default __webpack_public_path__ + "static/media/history.1245267f.svg";